import * as React from "react";
import classnames from "classnames";
import { Util, MediaQuery } from "@grandvisionhq/common";
import { createImageUrl } from "@grandvisionhq/utils";
/* empty css             */
const defaultImgSizes = {
  M: 768,
  L: 1024,
  XL: 1440,
  MAX: 1920
};
const Picture = ({
  url,
  mobileUrl,
  alt,
  className,
  height,
  width,
  imgSizes = defaultImgSizes,
  showImageAsCover
}) => {
  const defaultParams = { fit: "fillmax" };
  const mobileImgSizes = { M: imgSizes.M };
  const desktopImgSizes = { ...imgSizes, M: void 0 };
  const extraPixelDensities = [2];
  const mobileSrcSet = Util.createImageSrcSet(mobileUrl ?? url, mobileImgSizes, defaultParams, {
    extraPixelDensities
  });
  const mobileSizes = Util.createImageSizes(mobileImgSizes, mobileUrl ?? url, {
    extraPixelDensities
  });
  const desktopSrcSet = Util.createImageSrcSet(url, desktopImgSizes, defaultParams, {
    extraPixelDensities
  });
  const desktopSizes = Util.createImageSizes(desktopImgSizes, url, { extraPixelDensities });
  return /* @__PURE__ */ React.createElement("picture", { className: classnames("picture", className) }, /* @__PURE__ */ React.createElement(
    "source",
    {
      media: `(min-width: ${MediaQuery.Breakpoints.M}px)`,
      srcSet: desktopSrcSet,
      sizes: desktopSizes
    }
  ), mobileUrl && /* @__PURE__ */ React.createElement(
    "source",
    {
      media: `(max-width: ${MediaQuery.Breakpoints.M}px)`,
      srcSet: mobileSrcSet,
      sizes: mobileSizes
    }
  ), /* @__PURE__ */ React.createElement(
    "img",
    {
      height,
      width,
      className: classnames("picture__image", { "picture__image--cover": showImageAsCover }),
      src: createImageUrl(url, { ...defaultParams, width, height }),
      alt
    }
  ));
};
export {
  Picture as default
};
//# sourceMappingURL=Picture.js.map
